import React from 'react';
const Spinner: React.SFC = () => <div className="spinner" />;
export default Spinner;
